// extracted by mini-css-extract-plugin
export default {"content":"styles_content__oIO25","culture":"styles_culture__7l8JT","cultureimage":"styles_cultureimage__Gb6tn","culturetext":"styles_culturetext__rXcZn"};